/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceCreate } from '../models/ServiceCreate';
import type { ServiceOut } from '../models/ServiceOut';
import type { ServiceUpdate } from '../models/ServiceUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicesService {
    /**
     * List Services
     * @returns ServiceOut Successful Response
     * @throws ApiError
     */
    public static listServicesServicesGet(): CancelablePromise<Array<ServiceOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/services/',
        });
    }
    /**
     * Create Service
     * @param requestBody
     * @returns ServiceOut Successful Response
     * @throws ApiError
     */
    public static createServiceServicesPost(
        requestBody: ServiceCreate,
    ): CancelablePromise<ServiceOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/services/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Services By Client Type
     * @param userTypeId
     * @returns ServiceOut Successful Response
     * @throws ApiError
     */
    public static listServicesByClientTypeServicesUserTypeUserTypeIdGet(
        userTypeId: number,
    ): CancelablePromise<Array<ServiceOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/services/user_type/{user_type_id}',
            path: {
                'user_type_id': userTypeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Service
     * @param serviceId
     * @returns ServiceOut Successful Response
     * @throws ApiError
     */
    public static getServiceServicesServiceIdGet(
        serviceId: number,
    ): CancelablePromise<ServiceOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Service
     * @param serviceId
     * @param requestBody
     * @returns ServiceOut Successful Response
     * @throws ApiError
     */
    public static updateServiceServicesServiceIdPut(
        serviceId: number,
        requestBody: ServiceUpdate,
    ): CancelablePromise<ServiceOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Service
     * @param serviceId
     * @returns void
     * @throws ApiError
     */
    public static deleteServiceServicesServiceIdDelete(
        serviceId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
